<template>
  <div>
    <v-app-bar app flat height="66" color="white" class="dj-appbar">
      <router-link to="/" class="dj-appbar__brand">
        <v-img
          alt="DJ"
          :src="require('../../assets/logo.png')"
          max-width="34"
          contain
        />
        <span class="dj-appbar__wordmark">DJ</span>
      </router-link>

      <v-spacer></v-spacer>

      <div class="dj-appbar__nav">
        <v-btn class="dj-appbar__link" text to="/about-us"> About Us </v-btn>
        <v-btn class="dj-appbar__link" text to="/features"> Features </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="dj-appbar__link" text v-bind="attrs" v-on="on">
              Inquiries
              <v-icon right small>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item to="/contact-us">
              <v-list-item-title>Contact Us</v-list-item-title>
            </v-list-item>
            <v-list-item to="/careers">
              <v-list-item-title>Careers</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn color="primary" depressed class="ml-3" to="/auth/login">
          Login
        </v-btn>
      </div>
    </v-app-bar>

    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.dj-appbar {
  border-bottom: 1px solid var(--dj-border) !important;
}
.dj-appbar__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}
.dj-appbar__wordmark {
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: var(--dj-text);
}
.dj-appbar__nav {
  display: flex;
  align-items: center;
  gap: 2px;
}
.dj-appbar__link {
  color: var(--dj-text-soft) !important;
  font-weight: 600 !important;
}
</style>
